<div>
  <div class="card-body p-1">
    <div class="d-flex align-items-center">
      <span
        *ngIf="showArrows && !readonly"
        id="previousMed"
        class="clickable mr-2"
        style="align-self: start"
        matTooltip="Previous MedReview"
        (click)="previousMedReview()"
      >
        <i class="flaticon2-left-arrow icon-md"></i
      ></span>
      <div class="d-flex flex-grow-1" style="padding-left: 30px; padding-right: 30px">
        <div class="flex-shrink-0 mr-7">
          <div class="symbol symbol-85 gl-block">
            <img alt="Pic" [src]="data.patientImage || './assets/media/users/blank.jpg'" />
          </div>
        </div>

        <div class="flex-grow-1">
          <div class="d-flex align-items-center justify-content-between flex-wrap mt-2">
            <div class="mr-3">
              <div style="display: flex; align-items: flex-end">
                <span
                  *ngIf="data.patient_name"
                  class="d-flex align-items-center text-dark font-size-h5 font-weight-bold mr-3 mr-5 gl-block"
                  [ngClass]="{ 'cursor-pointer': fromMedReviewList }"
                  (click)="navigateToPatient(data)"
                  >{{ data.patient_name }}</span
                >
                <span
                  *ngIf="!data.patient_name"
                  class="d-flex align-items-center font-size-h5 mr-3 mr-5 gl-block font-weight-bold"
                  style="color: #e8e8e8"
                  >ABCE KIDNM KILOK KILOK</span
                >
                <span class="text-primary font-size-h5 font-weight-bold mr-lg-8 mb-lg-0 mb-2">
                  #<span>{{
                    data.patient_external_id && data.patient_external_id != 0
                      ? data.patient_external_id
                      : '00000'
                  }}</span>
                </span>
              </div>
              <div>
                <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                  Facility: {{ data.facility_name ? data.facility_name : 'facility name loading' }}
                </span>
                <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                  Cycle Date: {{ getCycleDateString() }}
                </span>
              </div>
              <div class="my-2">
                <div>
                  <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                    MedRev #:{{ data.id ? data.id : '00000' }}
                  </span>
                  <span class="text-muted font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                    <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                      <i class="ki ki-calendar-2"></i>
                    </span>
                    <span class="gl-block">{{
                      data.patient_dob ? (data.patient_dob | date : 'MM-dd-yyyy') : '-'
                    }}</span>
                  </span>
                </div>
                <div></div>
              </div>
            </div>
            <div class="position-relative d-inline-block" *ngIf="showClinicalCheckBox">
              <button
              class= "ks-btn-lg bg-light-neutral"
                style= "border: none; min-height: 60px; min-width: 130px"
                [style.height]="clinicalCheckFailed ? 'auto' : '60px'"
                (click)="showBambooData()"
              [disabled]="bambooHealthData?.engineResults?.length <= 0 || datanotfound || clinicalCheckFailed"
              >
                <div *ngIf="clinicalCheckFailed" class="ks-d-flex ks-flex-dir-column ks-w-100">
                  <p class="ks-text-danger ks-font-size-xs ks-font-weight-medium ks-mr-2"
                     style="text-transform: uppercase;">
                    Narxcare Unavailable </p>
                </div>
                <div *ngIf="datanotfound && !clinicalCheckFailed" class="ks-d-flex ks-flex-dir-column ks-w-100">
                  <p class="ks-text-neutral ks-font-size-xs ks-font-weight-medium ks-mr-2"
                     style="text-transform: uppercase;">
                   No Narxcare data </p>
                  <p class="ks-text-neutral ks-font-size-xs">
                    The search did not find PMP data for
                    this patient in the state where your query
                    was initiated.
                    {{bambooHealthData?.engineResults[0]?.riskScore.reportMessage}}</p>
                </div>
                <div *ngIf="bambooHealthData?.code === 422 && !clinicalCheckFailed" class="ks-d-flex ks-flex-dir-column ks-w-100">
                  <p class="ks-text-danger ks-font-size-xs ks-font-weight-medium ks-mr-2"
                     style="text-transform: uppercase;">
                    Narxcare Unavailable </p>
                  <p class="ks-text-neutral ks-font-size-xs">
                    {{bambooHealthData.message}}</p>
                </div>
                <div *ngIf="!bambooHealthData?.engineResults && !datanotfound && !clinicalCheckFailed" class="ks-d-flex ks-flex-dir-row ks-w-100" >
                  <p class="ks-text-neutral ks-font-size-sm ks-font-weight-medium ks-mr-2"
                     style="text-transform: uppercase;">
                    Narx Scores </p>
                  <span inlineSVG="assets/icons/Arrow-down.svg"> </span>
                </div>
                <div *ngIf="bambooHealthData?.engineResults[0]?.riskScore?.pickList && !clinicalCheckFailed" class="ks-d-flex ks-flex-dir-column ks-w-100" >
                  <p class="ks-text-neutral ks-font-size-xs ks-font-weight-medium ks-mr-2"
                     style="text-transform: uppercase;">
                    NarxCare </p>
                  <div class="ks-d-flex ks-flex-dir-row">
                    <p class="ks-text-secondary ks-font-size-sm ks-font-weight-medium ks-mr-2">
                      Multiple Patients Found</p>
                  <span inlineSVG="assets/icons/Arrow-down.svg"> </span>
                  </div>
                </div>
                <div *ngIf="bambooHealthData?.engineResults && bambooHealthData.engineResults[0]?.riskScore?.narxScores?.Overdose && !datanotfound && !clinicalCheckFailed"
                     class="ks-d-flex ks-flex-dir-column ks-w-100" >
                  <p class="ks-text-neutral ks-font-size-sm ks-font-weight-medium" style="text-transform: uppercase;">
                    Overdose </p>
                  <div class="ks-d-flex ks-flex-dir-row ks-column-gap-24">
                    <p class="ks-text-dark-neutral ks-font-size-lg ks-font-weight-bold"
                    >{{ bambooHealthData.engineResults[0].riskScore.narxScores.Overdose}}</p>
                    <span class="ks-badge-sm ks-font-weight-bold ks-text-white ks-mr-2 ks-ml-2
                    ks-bg-{{  overdoseLevel.color.replace('ks-text-', '') }}"
                          style="border-radius: 40px; min-width: 50px; text-transform: uppercase;"
                    >  {{ overdoseLevel.label }}</span>
                  <span inlineSVG="assets/icons/Arrow-down.svg"> </span>
                </div>
                </div>
              </button>
            </div>
            <div>
              <div class="d-flex mt-4 mt-sm-0" style="width: 260px !important">
                <div class="d-flex flex-column w-100 mr-2 clickable" (click)="openMedwiseTab()">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted mr-2 font-size-sm font-weight-bold"
                      ><span class="risk-score">{{ medWiseRiskScore }}</span> of
                      <span class="risk-score">50</span></span
                    >
                    <span class="text-muted font-size-sm font-weight-bold">
                      MedWise Risk Score:
                      <span class="risk-score">{{ medWiseRiskScoreString }}</span>
                    </span>
                  </div>
                  <div class="progress progress-xs w-100">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      [ngStyle]="{ width: getMedWiseRiskScore(), backgroundColor: mrsBarColor }"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div
                    [innerHTML]="getIndicators() | safe : 'html'"
                    class="indicators-cell mt-3"
                    (click)="$event.stopPropagation()"
                  ></div>
                </div>
              </div>
            </div>
            <div *ngIf="!readonly" class="my-lg-0 my-1">
              <div class="med-review-action" fxLayout="row" fxLayoutAlign="space-around center">
                <!--              <div class="mat-form-field-fluid">-->
                <!--                <mat-slide-toggle class="mr-2"></mat-slide-toggle>-->
                <!--              </div>-->

                <div style="width: 135px; align-self: flex-start; margin: 2px 15px 0 0">
                  <mat-select [formControl]="medType" class="btn btn-light text-left">
                    <mat-option value="">All</mat-option>
                    <mat-option value="C">Maintenance</mat-option>
                    <mat-option value="!C">Not Maintenance</mat-option>
                  </mat-select>
                  <mat-hint>{{ 'GLOBAL.FILTER_BY' | translate }}<strong>Med Type</strong></mat-hint>
                </div>
                <div>
                  <ng-template ngxPermissionsOnly="canAddTask">
                    <div class="btn-group">
                      <button
                        type="button"
                        data-toggle="dropdown"
                        matTooltip="Create Task"
                        class="btn btn-icon btn-light dropdown-toggle mr-2"
                      >
                        <span
                          inlineSVG="assets/media/svg/icons/Files/Clipboard-check.svg"
                          class="svg-icon svg-icon-md"
                        ></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-left dropdown-menu-anim-up p-15px">
                        <div class="font-weight-bold mb-15px">
                          {{ 'MED_REVIEW.RELATED_TASK_TEMPLATE' | translate }}
                        </div>
                        <div
                          style="width: 300px !important; max-height: 200px !important"
                          class="scroll"
                          [perfectScrollbar]="{ wheelPropagation: false }"
                        >
                          <div
                            *ngFor="let template of relatedTaskTemplates"
                            class="bg-hover-light px-4 py-2"
                            (click)="createTask($event, template.id)"
                          >
                            {{ template.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <button
                    matTooltip="Follow-Up"
                    class="btn btn-icon btn-light mr-2"
                    (click)="openFollowUpDialog(data)"
                  >
                    <i class="flaticon-calendar-with-a-clock-time-tools"></i>
                  </button>
                  <button
                    matTooltip="Comments"
                    class="btn btn-icon btn-light mr-4"
                    (click)="openCommentsDialog($event, data.id)"
                  >
                    <i class="flaticon-comment"></i>
                  </button>
                  <div class="btn-group btn-group-md" *ngIf="fromMedReviewList">
                    <button
                      mat-raised-button
                      style="box-shadow: none !important"
                      class="btn btn-secondary"
                      (click)="completeAndNext()"
                    >
                      <span>Complete & Next</span>
                    </button>
                    <div class="btn-group btn-group-md" style="width: 30px">
                      <button
                        mat-raised-button
                        matTooltip="Complete Review"
                        data-toggle="dropdown"
                        [disabled]="isViewMode"
                        style="
                          border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
                          box-shadow: none !important;
                          width: 40px !important;
                          min-width: min-content;
                        "
                        class="btn btn-icon btn-secondary dropdown-toggle"
                      >
                        <span
                          inlineSVG="assets/media/svg/icons/Navigation/Angle-down.svg"
                          class="svg-icon svg-icon-md"
                        ></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" (click)="completeMedReview()"> Complete Review </a>
                      </div>
                    </div>
                  </div>
                  <!--                <button class="mr-2" mat-flat-button color="primary" (click)="completeMedReview()" [disabled]="isViewMode">Complete Review</button>-->
                  <!--                <button  mat-flat-button color="primary" (click)="completeAndNext()" [disabled]="showWarning && false" *ngIf="showArrows">Complete & Next</button>-->
                  <div class="d-flex align-items-center flex-wrap">
                    <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                      <div
                        class="med-review-action"
                        fxLayout="row"
                        fxLayoutAlign="space-around center"
                      >
                        <div>
                          <span
                            class="svg-icon svg-icon-3x text-muted"
                            [inlineSVG]="'./assets/media/svg/icons/General/heart.svg'"
                            matTooltip="Launch Care Monitor"
                          ></span>
                        </div>
                        <div>
                          <span
                            class="svg-icon svg-icon-3x"
                            [ngClass]="{
                              'svg-icon-warning cursor-pointer': showWarningDRP | async
                            }"
                            [inlineSVG]="'./assets/media/svg/icons/General/Warning-1-circle.svg'"
                            (click)="openDrpDialog()"
                            matTooltip="DRP"
                          ></span>
                        </div>
                        <div>
                          <span
                            class="svg-icon svg-icon-3x"
                            [ngClass]="{ 'svg-icon-warning cursor-pointer': showWarningOb | async }"
                            [inlineSVG]="'./assets/media/svg/icons/Code/Warning-2.svg'"
                            (click)="onWarningClicked($event)"
                            matTooltip="PV1"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center flex-wrap"></div>
        </div>
      </div>
      <span
        *ngIf="showArrows && !readonly"
        id="nextMed"
        class="clickable ml-2"
        style="align-self: start"
        matTooltip="Next MedReview"
        (click)="nextMedReview()"
      >
        <i class="flaticon2-right-arrow icon-md"></i>
      </span>
    </div>
    <div class="separator separator-solid my-1"></div>
  </div>
</div>
